// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"ModalMentionLegal-module--close-button--3h9EW"};